// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"d6b498e09102d5d414bd","532":"eaa888415e3d9d4b0493","691":"374b995b7dbced1bf8c3","883":"b98fdea6d02d35fe36cc"}[chunkId] + ".js";
};